/*
    ---- Html ----
    Displays HTML
*/

import React from "react";

function Html(props) {
  const { html, className = "bm-lnkin-0" } = props;
  const display = () => {
    return { __html: html };
  }
  return (<><div style={{ "overflow": "hidden"}} className={"html htmlcolor " + className} dangerouslySetInnerHTML={display()}></div></>);
}

export default Html;